<template>
	<div v-if="data">
		<template v-if="$platform.setting">
			<template v-if="$platform.setting.display_profit">
				<h5>Margen de beneficio</h5>
				<h4 :class="nameClass">
					<template v-if="data.profit_value">
						{{ data.profit_value }}
						<template v-if="currency">
							{{ currency.symbol }}
						</template>
					</template>
					<template v-if="edit">
						<div class="input-group">
							<input @keyup.enter="calculateBasePrice" v-model="profit_percent" ref="inputPercent" type="number" class="form-control">
							<div class="input-group-btn">
								<button @click="calculateBasePrice" class="btn btn-defult" type="button">
									<i class="fa fa-check" aria-hidden="true"></i>
								</button>
								<button @click="toogle" class="btn btn-defult" type="button">
									<i class="fa fa-times" aria-hidden="true"></i>
								</button>
							</div>
						</div>
					</template>
					<template v-else>
						{{ data.profit_percent }}
						<template v-if="data.profit_percent">
							%
						</template>
						<button @click="toogle" class="btn btn-defult" type="button"><i class="fa fa-percent" aria-hidden="true"></i></button>
					</template>
					<div>
						{{ data.profit_value }}
						<template v-if="currency">
							{{ currency.symbol }}
						</template>
						x {{ data.total_measurement_unit }}
						<template v-if="data.measurement_unit">
							{{ data.measurement_unit.name }}
						</template>
						= {{ data.profit_val_measurement_unit }}
						<template v-if="currency">
							{{ currency.symbol }}
						</template>
					</div>
				</h4>
			</template>
		</template>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data', 'currency'],
		data () {
			return {
				nameClass: null,

				edit: false,

				profit_percent: this.data.profit_percent,
			}
		},
		watch: {
			'profit_percent'() {
				this.data.profit_percent = this.$options.filters.checkDecimals(this.data.profit_percent)
			},
			edit() {
				this.profit_percent = this.data.profit_percent
			},
		},
		methods: {
			toogle() {
				this.edit = !this.edit
				if(this.edit) {
					this.$nextTick( () => {
						$(this.$refs.inputPercent).select().focus()
					})
				}
			},
			calculateProfit() {
				this.calculateValue()
				this.calculatePercent()
				this.calculateValueMeasurementUnit()
				this.loadClass()
			},
			calculateValue() {
				var purchase_price = 0
				if(this.data.purchase_price) {
					purchase_price = parseFloat(this.data.purchase_price).toFixed(2)
				}

				var price = 0
				if(this.data.price) {
					price = parseFloat(this.data.price).toFixed(2)
				}
				var profit_value = parseFloat(price - purchase_price).toFixed(2)
				this.data.profit_value = profit_value
			},
			calculatePercent() {
				var purchase_price = 0
				if(this.data.purchase_price) {
					purchase_price = parseFloat(this.data.purchase_price).toFixed(2)
				}

				var price = 0
				if(this.data.price) {
					price = parseFloat(this.data.price).toFixed(2)
				}

				var profit_value = 0
				if(this.data.profit_value) {
					profit_value = parseFloat(this.data.profit_value).toFixed(2)
				}

				if(purchase_price > 0) {
					var profit_percent = profit_value * 100
					if(profit_percent == 0) {
						profit_percent = 0
					} else {
						profit_percent = profit_percent / purchase_price
					}
				} else {
					if(price > 0) {
						var profit_percent = 100
					} else {
						var profit_percent = 0
					}
				}

				this.data.profit_percent = parseFloat(profit_percent).toFixed(2)
			},
			calculateBasePrice() {
				var purchase_base_price = 0
				if(this.data.purchase_base_price) {
					purchase_base_price = Number(parseFloat(this.data.purchase_base_price).toFixed(2))
				}

				var profit_percent = 0
				if(this.profit_percent) {
					profit_percent = parseFloat(this.profit_percent).toFixed(2)
				}

				var value = Number(parseFloat(purchase_base_price * (profit_percent / 100)).toFixed(2))
				var base_price = purchase_base_price + value

				this.data.base_price = base_price
				this.toogle()
			},
			calculateValueMeasurementUnit() {
				var profit_value = 0
				if(this.data.profit_value) {
					profit_value = this.data.profit_value
				}

				var total_measurement_unit = 1
				if(this.data.total_measurement_unit) {
					total_measurement_unit = this.data.total_measurement_unit
				}

				var profit_val_measurement_unit = profit_value * total_measurement_unit
				this.data.profit_val_measurement_unit = parseFloat(profit_val_measurement_unit).toFixed(2)
			},
			loadClass() {
				if(this.data.profit_value == 0) {
					this.nameClass = 'text-muted'
				} else {
					if(this.data.profit_value < 0) {
						this.nameClass = 'text-danger'
					} else {
						this.nameClass = 'text-success'
					}
				}
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/products/views/Profit.vue